import { Box, SxProps, Theme } from "@mui/material";
import React from "react";

import { HOLE, INNER, LOGO_BLUE, OUTER } from "./LogoLoader";

// The mark's own box, the outer triangle's bounds
const VIEW_BOX = "0 0 488 422.62";
const ASPECT = 422.62 / 488;

interface LogoMarkProps {
  // Width (px); the height follows the mark
  size: number;
  sx?: SxProps<Theme>;
}

/**
 * The logo's mark, still: the ring in the colour of the text around it, so
 * that it stands on a light page as on a dark one, and the inner triangle in
 * the logo's blue.
 */
const LogoMark: React.FC<LogoMarkProps> = ({ size, sx }) => (
  <Box
    component="svg"
    viewBox={VIEW_BOX}
    aria-hidden
    sx={[
      { width: size, height: size * ASPECT, display: "block", flexShrink: 0 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <path d={`${OUTER} ${HOLE}`} fillRule="evenodd" fill="currentColor" />
    <path d={INNER} fill={LOGO_BLUE} />
  </Box>
);

export default LogoMark;
